var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecorationYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 27,
    viewBox: "0 0 176 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23661 0.53418H-15.0186L-31.1953 26.7291H-15.0186L2.23661 0.53418Z",
    fill: "#FFDD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0413 0.53418H9.78611L-6.39062 26.7291H9.78611L27.0413 0.53418Z",
    fill: "#FFDD00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4866 0.53418H34.2314L18.0547 26.7291H34.2314L51.4866 0.53418Z",
    fill: "#FFDD00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2913 0.53418H59.0361L42.8594 26.7291H59.0361L76.2913 0.53418Z",
    fill: "#FFDD00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.088 0.53418H83.833L67.6562 26.7291H83.833L101.088 0.53418Z",
    fill: "#FFDD00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.901 0.53418H108.645L92.4688 26.7291H108.645L125.901 0.53418Z",
    fill: "#FFDD00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.346 0.53418H133.091L116.914 26.7291H133.091L150.346 0.53418Z",
    fill: "#FFDD00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.143 0.53418H157.888L141.711 26.7291H157.888L175.143 0.53418Z",
    fill: "#FFDD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorationYellow);
export default __webpack_public_path__ + "static/media/decoration_yellow.8b088913daff4ce6cf56edf92ea062db.svg";
export { ForwardRef as ReactComponent };